import React from 'react';
import { Modal, ModalProps, Row } from 'antd';
import { translate } from '@portal/services/i18n';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';

interface MessageModalProps extends ModalProps {
  message?: string;
  onConfirm?: () => void;
  setVisible: (visible: false) => void;
  onCancel?: () => void;
  title?: string;
  buttonOkText?: string;
  buttonCancelText?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cancelButtonCustomStyles?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmButtonCustomStyles?: any;
  children?: JSX.Element;
  titleAlign?: 'center' | 'start' | 'end';
  buttonsAlign?: 'center' | 'start' | 'end';
  messageAlign?: 'center' | 'start' | 'end';
  disabledConfirmButton?: boolean;
}

const MessageModal = ({
  title,
  message,
  setVisible,
  onCancel,
  onConfirm,
  buttonOkText,
  buttonCancelText,
  cancelButtonCustomStyles,
  confirmButtonCustomStyles,
  children,
  titleAlign,
  messageAlign,
  buttonsAlign,
  disabledConfirmButton,
  ...modalProps
}: MessageModalProps) => {
  return (
    <Modal
      footer={null}
      onCancel={() => setVisible(false)}
      className="message-modal"
      zIndex={50}
      {...modalProps}
    >
      {title ? (
        <p className={`message-modal__title--${titleAlign ?? 'center'}`}>
          {title}
        </p>
      ) : null}
      {message ? (
        <p className={`message-modal__message--${messageAlign ?? 'center'}`}>
          {message}
        </p>
      ) : null}
      {children}
      <Row justify={buttonsAlign ?? 'center'}>
        {onCancel ? (
          <AdvancedButton
            text={buttonCancelText || translate('SHARED.CANCEL')}
            onClick={onCancel}
            customStyles={cancelButtonCustomStyles}
          />
        ) : null}
        {onConfirm ? (
          <div className="message-modal__button">
            <AdvancedButton
              text={buttonOkText || translate('SHARED.CONFIRM')}
              onClick={onConfirm}
              disabled={disabledConfirmButton}
              customStyles={confirmButtonCustomStyles}
            />
          </div>
        ) : null}
      </Row>
    </Modal>
  );
};

export default MessageModal;
